import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { orderAutomationApi } from 'api';
import {
  DataGridColumnDefinition,
  OrderAutomationStatusLabel,
} from 'components';
import {
  FilterDefinitionType,
  OrderAutomationFilterTypes,
  OrderAutomationSpamStatus,
  QueryKey,
} from 'enums';
import { usePartialQuery, useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';
import {
  FilterDefinition,
  OrderAutomation,
  OrderAutomationFilters,
} from 'types';
import { formatUtils, orderAutomationUtils } from 'utils';

import { ManageOrderAutomationList } from '../ManageOrderAutomationList';

export const SpamOrderAutomation: React.FC = () => {
  const { t: tColumns } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.order_automation.table.columns',
  });

  const { role } = useUser();

  const queryResult = usePartialQuery(
    QueryKey.SpamOrderAutomation,
    orderAutomationApi.getMessagesPaginatedAsRole(
      role,
      OrderAutomationFilterTypes.Spam,
    ),
    { useCachedCount: true },
  );

  const additionalColumns = useMemo(
    (): DataGridColumnDefinition<OrderAutomation>[] => [
      {
        header: tColumns('status'),
        valueGetter: (item) => (
          <OrderAutomationStatusLabel status={item.status} />
        ),
      },
      {
        header: tColumns('reviewed'),
        valueGetter: (item) => (
          <Fragment>
            {item.reviewedBy?.name && <div>{item.reviewedBy.name}</div>}
            {item.reviewedAt && (
              <div>{formatUtils.formatDate(item.reviewedAt)}</div>
            )}
          </Fragment>
        ),
      },
    ],
    [tColumns],
  );

  const additionalFilters: FilterDefinition<OrderAutomationFilters>[] = useMemo(
    () => [
      {
        label: tColumns('status'),
        name: 'status',
        type: FilterDefinitionType.Enum,
        enum: OrderAutomationSpamStatus,
        getDisplayName: orderAutomationUtils.getStatusLabel,
      },
    ],
    [tColumns],
  );

  return (
    <ManageOrderAutomationList
      queryResult={queryResult}
      additionalColumns={additionalColumns}
      additionalFilters={additionalFilters}
    />
  );
};
